<script>
    import productImagePreview from "@/components/App/product-image-preview.vue";

    import { CommonMixin } from '@/mixins/commonMethods';
    import {loadImg} from "@/mixins/loadImg";

    export default {
        name: "Similar products",
        components: {productImagePreview},
        mixins: [CommonMixin, loadImg],
        props: {
            similarProducts: {
                type: Array,
                required: true
            }
        },
        data: () => ({
            sizes: {
                XS: 'X-Small',
                S: 'Small',
                M: 'Medium',
                L: 'Large',
                XL: 'X-Large',
                XXL: 'XX-Large',
            },
        }),
        computed: {
            filteredItems() {
                return this.similarProducts
            }
        },
        created() {
            this.loadImages(); // Загружаем изображения сразу при создании компонента
        },

        watch: {
            similarProducts(newValue) {
                if(newValue?.length > 0) {
                    this.loadImages();
                }
            }
        }
    }
</script>

<template>
    <div class="similar-products-block" v-if="similarProducts.length > 1">
        <h4>Вам может понравиться</h4>
        <div class="no-similar-products" v-if="similarProducts.length < 1">
            <span>Похожих продуктов нет</span>
        </div>
        <div class="similar-products" v-else>
            <div class="col-4 similar-product-elem" v-for="product of similarProducts">

                <router-link :to="{ name: 'product-item', params: { code: product['Код'] } }">
                    <product-image-preview
                        :headerImage=setImageThumbURL(product.imageUrl)
                        :images=product.images
                        :actProduct="product"
                    ></product-image-preview>
                    <div class="product-text-block">
                        <h3 class="product-name">{{ product["Название продукта"] }}</h3>
                        <p class="product-size">{{ this.sizes[product["Размер"]] }}</p>
                        <div class="sale-block" v-if="product['Цена по скидке'] !== 0">
                            <p class="sale-price">{{ product['Цена по скидке'] }}&#8381;</p>
                            <p class="default-price">{{ product['Обычная цена'] }}&#8381;</p>
                        </div>
                        <div class="default-block" v-else>
                            <p class="sale-price">{{ product['Обычная цена'] }}&#8381;</p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

.similar-products {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 1.2%;
}

.similar-products .similar-product-elem {
    width: 18.8%;
}

.similar-products-block {
    margin-top: 10px;
    margin-bottom: 10px;
}

.product-text-block {
    display: flex;
    gap: 3px;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

h3.product-name {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
}

h4 {
    font-size: 26px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 2%;
}

.no-similar-products {
    text-align: center;
}

p.product-size {
    font-family: "PT Sans";
    font-weight: 700;
    color: $hard-gray
}

.sale-block {
    display: flex;
    align-items: center;
    margin-top: 10px;
    gap: 10px
}

.sale-price {
    font-size: 22px;
    font-weight: 500;
}

.default-price {
    font-size: 12px;
    color: $hard-gray;
    text-decoration: line-through;
}

@media screen and (max-width: 750px) {
    h4 {
        font-size: 22px;
        margin-bottom: 20px;
        //text-align: left;
    }

    .similar-products {
        overflow-x: auto;
        gap: 10px;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    .similar-products .similar-product-elem {
        width: 45%;
    }

    h3.product-name {
        font-size: 16px;
    }

    p.product-size {
        font-size: 12px;
    }

    .sale-price {
        font-size: 18px;
    }

    .default-price {
        font-size: 10px;
    }
}

</style>
